import { combineReducers, ThunkAction, Action, Dispatch, Reducer } from '@reduxjs/toolkit';
import { acceptanceAdvancedReducer } from './acceptanceAdvancedSlice';
import { globalPollingReducer } from './globalPollingSlice';

interface RootState {
  acceptanceAdvanced: ReturnType<typeof acceptanceAdvancedReducer>;
  globalPolling: ReturnType<typeof globalPollingReducer>;
}

const rootReducer = combineReducers({
  acceptanceAdvanced: acceptanceAdvancedReducer,
  globalPolling: globalPollingReducer,
}) as Reducer<RootState>;

export type AppDispatch = Dispatch;
export type AppThunk<ThunkReturnType = void> = ThunkAction<ThunkReturnType, RootState, unknown, Action>;
export type { RootState };

export default rootReducer;

export * from './acceptanceAdvancedSlice/selectors';
export * from './acceptanceAdvancedSlice/slice';

export * from './globalPollingSlice/slice';
